import React, { Component } from 'react'

import OtherProjectTable from '../Tables/OtherProjectTable'
import DownloadDataLink from '../Tables/DownloadDataLink'

class Home extends Component {
  constructor (props) {
    super(props)
    this.state = {
      filter: null
    }
    this.applyFilter = this.applyFilter.bind(this)
  }

  applyFilter (filter) {
    this.setState({ filter })
  }

  render () {
    const otherProjects = this.props.data.otherProjects
      ? Object.values(this.props.data.otherProjects)
      : []

    const id = 'other-projects'

    return (
      <div>
        <div className='row'>
          <div className='col'>
            <h1>Other projects</h1>
            <DownloadDataLink forId={id} filename={id} />
          </div>
        </div>
        <OtherProjectTable id={id} otherProjects={otherProjects} />
      </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/components/App/OtherProjects.js